import { labelKey } from '.';
export var createLabelDriver = function (wrapper) {
    var base = wrapper.$("." + labelKey);
    return {
        text: function () { return base.text(); },
        isRemovable: function () { return base.$('.remove-icon .icon').exists(); },
        removeClick: function () { return base.$('.remove-icon .icon').click(); },
        click: function () { return base.click(); },
        base: base,
    };
};
//# sourceMappingURL=driver.js.map